import request from '../request';

const server = {
  // 新增
  addressAdd(params) {
    return request.post(`user-center/address/ship/add`, params);
  },
  // 批量删除
  batchDelete(params) {
    return request.post(`user-center/address/ship/batchDelete`, params);
  },
  // 获取地址详情
  getInfo(params) {
    return request.post(`user-center/address/ship/getInfo`, params);
  },
  // 更新
  modify(params) {
    return request.post(`user-center/address/ship/modify`, params);
  },
  // 获取参展申请列表
  queryList(params) {
    return request.post(`user-center/address/ship/queryList`, params);
  },
  // 获取发货地址列表-分页
  queryPage(params) {
    return request.post(`user-center/address/ship/queryPage`, params);
  },
  // 根据国家编码查询地区，如果是中国返回的是省的list
  queryAreaByCountryCode(params) {
    return request.post(`user-center/area/queryAreaByCountryCode`, params);
  },
  // 根据省返回市
  getCityByAreaId(params) {
    return request.post(`user-center/area/getCityByAreaId`, params);
  },
  // 根据市返回区县
  getDistrictByCityId(params) {
    return request.post(`user-center/area/getDistrictByCityId`, params);
  },
  // 分页查询用户收货地址（下单时调用）
  addressApi_pageMemberAddress(params) {
    return request.post(`user-center/address/pageMemberAddress`, params);
  },
  // 新增收货地址或者发票邮寄地址
  addressApi_addressAdd(params) {
    return request.post(`user-center/address/add`, params);
  },
  // 修改收货地址或者发票邮寄地址
  addressApi_addressModify(params) {
    return request.post(`user-center/address/modify`, params);
  },
  // 批量删除收货地址或者发票邮寄地址
  addressApi_addressDelete(params) {
    return request.post(`user-center/address/batchDelete`, params);
  },
};

export default server;
